module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/64390a79871b775efaf2daa11e30dc84.png";